import "core-js/modules/es.array.push.js";
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0
};
import { threadList } from '@/api/mg';
export default {
  watch: {
    inputValue: function inputValue() {
      threadListParams['filter[search]'] = this.inputValue;
      this.getThreadList(threadListParams);
    }
  },
  props: ['inputValue'],
  data: function data() {
    return {
      allData: []
    };
  },
  created: function created() {
    threadListParams.page = 1;
    threadListParams['filter[search]'] = this.inputValue;
    this.getThreadList(threadListParams);
  },
  methods: {
    getThreadList: function getThreadList(params) {
      var _this = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          // this.$toast(res.Message)
          // this.totalPage = res.Data.totalPage
          // this.clubData = [...this.clubData, ...res.Data.pageData]
          _this.allData = res.Data.pageData;
          if (_this.allData.length === 0) {
            _this.$toast('No Data');
          }
          console.log(_this.allData, 'this.allData');
          // this.loading = false
          // this.isLoading = false
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toChange: function toChange(name) {
      this.$emit('tabChange', name);
    },
    toDetail: function toDetail(val, threadId) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: val,
          threadId: threadId
        }
      });
    }
  }
};